import Vue from 'vue';
import { Chart } from '@antv/g2'; // 修改为按需加载
import DataSet from '@antv/data-set';
export default Vue.extend({
    name: 'incomeChart',
    components: {},
    data: function () {
        return {
            chart: null,
        };
    },
    props: {
        charData: {
            type: Array,
            default: function () {
                return {
                    data: [],
                };
            },
        },
        hasData: {
            type: Boolean,
            default: true,
        },
    },
    mounted: function () {
        if (this.hasData) {
            this.drawChart();
        }
    },
    watch: {
        charData: function (val, oldVal) {
            // 监听charData，当放生变化时，触发这个回调函数绘制图表
            this.$refs['incomeChart'].innerHTML = '';
            if (this.hasData) {
                this.drawChart();
            }
        },
    },
    methods: {
        drawChart: function () {
            var startAngle = -Math.PI / 2 - Math.PI / 4;
            var ds = new DataSet();
            var dv = ds.createView().source(this.charData);
            dv.transform({
                type: 'percent',
                field: 'value',
                dimension: 'type',
                as: 'percent',
            });
            var chart = new Chart({
                container: 'income-chart',
                width: 500,
                height: 180,
                padding: 'auto',
            });
            this.chart = chart;
            chart.source(dv);
            chart.legend(false);
            chart.coord('theta', {
                radius: 0.75,
                innerRadius: 0.3,
                startAngle: startAngle,
                endAngle: startAngle + Math.PI * 2,
            });
            chart
                .intervalStack()
                .position('value')
                .color('type', ['#40ad90', '#55c4bb', '#2f8373'])
                .opacity(1);
            chart.render();
            //draw label
            var OFFSET = 10;
            var APPEND_OFFSET = 100;
            var LINEHEIGHT = 50;
            var coord = chart.get('coord'); // 获取坐标系对象
            var center = coord.center; // 极坐标圆心坐标
            var r = coord.radius; // 极坐标半径
            var canvas = chart.get('canvas');
            var canvasWidth = chart.get('width');
            var canvasHeight = chart.get('height');
            var labelGroup = canvas.addGroup();
            var labels = [];
            function drawLabel(label) {
                var _anchor = label._anchor, _router = label._router, fill = label.fill, y = label.y;
                var labelAttrs = {
                    y: y + 16,
                    fontSize: 12,
                    color: '#666F83',
                    fill: '#808080',
                    text: label._data.type + '\n' + ("\uFFE5" + label._data.value),
                    textBaseline: 'bottom',
                };
                var lastPoint = {
                    y: y,
                };
                if (label._side === 'left') {
                    // 具体文本的位置
                    lastPoint.x = APPEND_OFFSET;
                    labelAttrs.x = APPEND_OFFSET; // 左侧文本左对齐并贴着画布最左侧边缘
                    labelAttrs.textAlign = 'left';
                }
                else {
                    lastPoint.x = canvasWidth - APPEND_OFFSET;
                    labelAttrs.x = canvasWidth - APPEND_OFFSET; // 右侧文本右对齐并贴着画布最右侧边缘
                    labelAttrs.textAlign = 'right';
                }
                // 绘制文本
                var text = labelGroup.addShape('Text', {
                    attrs: labelAttrs,
                });
                labels.push(text);
                // 绘制连接线
                var points = void 0;
                if (_router.y !== y) {
                    // 文本位置做过调整
                    points = [
                        [_anchor.x, _anchor.y],
                        [_router.x, y],
                        [lastPoint.x, lastPoint.y],
                    ];
                }
                else {
                    points = [
                        [_anchor.x, _anchor.y],
                        [_router.x, _router.y],
                        [lastPoint.x, lastPoint.y],
                    ];
                }
                labelGroup.addShape('polyline', {
                    attrs: {
                        points: points,
                        lineWidth: 1,
                        stroke: fill,
                    },
                });
            }
            function antiCollision(half, isRight) {
                var startY = center.y - r - OFFSET - LINEHEIGHT;
                var overlapping = true;
                var totalH = canvasHeight;
                var i = void 0;
                var maxY = 0;
                var minY = Number.MIN_VALUE;
                var boxes = half.map(function (label) {
                    var labelY = label.y;
                    if (labelY > maxY) {
                        maxY = labelY;
                    }
                    if (labelY < minY) {
                        minY = labelY;
                    }
                    return {
                        size: LINEHEIGHT,
                        targets: [labelY - startY],
                    };
                });
                if (maxY - startY > totalH) {
                    totalH = maxY - startY;
                }
                while (overlapping) {
                    boxes.forEach(function (box) {
                        var target = (Math.min.apply(minY, box.targets) +
                            Math.max.apply(minY, box.targets)) /
                            2;
                        box.pos = Math.min(Math.max(minY, target - box.size / 2), totalH - box.size);
                    });
                    // detect overlapping and join boxes
                    overlapping = false;
                    i = boxes.length;
                    while (i--) {
                        if (i > 0) {
                            var previousBox = boxes[i - 1];
                            var box = boxes[i];
                            if (previousBox.pos + previousBox.size > box.pos) {
                                // overlapping
                                previousBox.size += box.size;
                                previousBox.targets = previousBox.targets.concat(box.targets);
                                // overflow, shift up
                                if (previousBox.pos + previousBox.size > totalH) {
                                    previousBox.pos = totalH - previousBox.size;
                                }
                                boxes.splice(i, 1); // removing box
                                overlapping = true;
                            }
                        }
                    }
                }
                // step 4: normalize y and adjust x
                i = 0;
                boxes.forEach(function (b) {
                    var posInCompositeBox = startY; // middle of the label
                    b.targets.forEach(function () {
                        half[i].y = b.pos + posInCompositeBox + LINEHEIGHT / 2;
                        posInCompositeBox += LINEHEIGHT;
                        i++;
                    });
                });
                // (x - cx)^2 + (y - cy)^2 = totalR^2
                half.forEach(function (label) {
                    var rPow2 = label.r * label.r;
                    var dyPow2 = Math.pow(Math.abs(label.y - center.y), 2);
                    if (rPow2 < dyPow2) {
                        label.x = center.x;
                    }
                    else {
                        var dx = Math.sqrt(rPow2 - dyPow2);
                        if (!isRight) {
                            // left
                            label.x = center.x - dx;
                        }
                        else {
                            // right
                            label.x = center.x + dx;
                        }
                    }
                    drawLabel(label);
                });
            }
            function getEndPoint(center, angle, r) {
                return {
                    x: center.x + r * Math.cos(angle),
                    y: center.y + r * Math.sin(angle),
                };
            }
            function addPieLabel() {
                var halves = [[], []];
                var data = dv.rows;
                var angle = startAngle;
                for (var i = 0; i < data.length; i++) {
                    var percent = data[i].percent;
                    var targetAngle = angle + Math.PI * 2 * percent;
                    var middleAngle = angle + (targetAngle - angle) / 2;
                    angle = targetAngle;
                    var edgePoint = getEndPoint(center, middleAngle, r);
                    var routerPoint = getEndPoint(center, middleAngle, r + OFFSET);
                    //label
                    var label = {
                        _anchor: edgePoint,
                        _router: routerPoint,
                        _data: data[i],
                        x: routerPoint.x,
                        y: routerPoint.y,
                        r: r + OFFSET,
                        fill: '#bfbfbf',
                    };
                    // 判断文本的方向
                    if (edgePoint.x < center.x) {
                        label._side = 'left';
                        halves[0].push(label);
                    }
                    else {
                        label._side = 'right';
                        halves[1].push(label);
                    }
                }
                var maxCountForOneSide = parseInt(canvasHeight / LINEHEIGHT, 10);
                halves.forEach(function (half, index) {
                    // step 2: reduce labels
                    if (half.length > maxCountForOneSide) {
                        half.sort(function (a, b) {
                            return b._percent - a._percent;
                        });
                        half.splice(maxCountForOneSide, half.length - maxCountForOneSide);
                    }
                    // step 3: distribute position (x and y)
                    half.sort(function (a, b) {
                        return a.y - b.y;
                    });
                    antiCollision(half, index);
                });
            }
            addPieLabel(chart);
            canvas.draw();
            chart.on('afterpaint', function () {
                addPieLabel(chart);
            });
        },
    },
});
